<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-modal-close" aria-label="Close" (click)="closeModal()">
    <span class="material-icons-outlined">close</span>
  </button>
</div>
<div class="modal-body">
  <p [innerHTML]="message" style="color: #444; line-height: 1.7; margin: 0"></p>
</div>
